import { ComponentPropsWithoutRef } from 'react';

export const ArrowIcon = ({ ...props }: ComponentPropsWithoutRef<'svg'>) => {
  return (
    <svg {...props} fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M19 9l-7 7-7-7"
      />
    </svg>
  );
};
